
declare const $;
export function validate_directive($q: ng.IQService) {
    "ngInject";

    var directive = {
        link: link,
        restrict: 'A',
        require: "ngModel",
        scope: {
            validate: "="
        }
    };
    return directive;

    function link(scope, element, attrs, ngModel) {
        let dynamicFunction = {
            check_nationalCode: check_nationalCode
        }
        let listOfValidate = scope.validate
        for (let validate of listOfValidate) {
            ngModel.$asyncValidators[validate] = function (modelValue, viewValue) {
                return $q((resolve, reject) => {
                    if (dynamicFunction["check_" + validate](viewValue)) {
                        resolve(true)
                    }
                    else {
                        reject(false)
                    }

                })
            }
        }
    }
}


function ControllerController() {

}



function check_nationalCode(codeMelli) {
    if (codeMelli.length == 10) {
        switch (codeMelli) {
            case '0000000000':
            case '1111111111':
            case '2222222222':
            case '3333333333':
            case '4444444444':
            case '5555555555':
            case '6666666666':
            case '7777777777':
            case '8888888888':
            case '9999999999':
                return false;
        }
        var c = parseInt(codeMelli.charAt(9));
        var sum = parseInt(codeMelli.charAt(0)) * 10 +
            parseInt(codeMelli.charAt(1)) * 9 +
            parseInt(codeMelli.charAt(2)) * 8 +
            parseInt(codeMelli.charAt(3)) * 7 +
            parseInt(codeMelli.charAt(4)) * 6 +
            parseInt(codeMelli.charAt(5)) * 5 +
            parseInt(codeMelli.charAt(6)) * 4 +
            parseInt(codeMelli.charAt(7)) * 3 +
            parseInt(codeMelli.charAt(8)) * 2;
        let a = Math.floor(sum / 11);
        var r = sum - a * 11;
        return (r == 0 && r == c) || (r == 1 && c == 1) || (r > 1 && c == 11 - r);
    }
    return false;
}


// WEBPACK FOOTER //
// ./src/directives/validate/validate.ts